import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {screenSizeSmaller} from 'views/components';
import {useLocation} from 'views/module';

import NavbarBigScreen from './navbar_big_screen';
import NavbarSmallScreen from './navbar_small_screen';

const NavBar = (props) => {
  const mobileApp = props.mobileApp;

  const smallScreen = screenSizeSmaller('navbarHide');
  const location = useLocation();

  const [account, setAccount] = React.useState('care');

  const handleSetAccount = (acc) => {
    setAccount(acc);
    localStorage.setItem('ACCOUNT_TAB', acc);
  };

  React.useEffect(() => {
    const savedAccount = localStorage.getItem('ACCOUNT_TAB');
    if (savedAccount) {
      setAccount(savedAccount);
    }
  }, []);

  React.useEffect(() => {
    const pathname = location.pathname;
    let result = null;
    if (pathname.startsWith('/caregiver') || pathname.startsWith('/career')) {
      result = 'recruiter';
    }

    if (pathname.startsWith('/client') || pathname.startsWith('/schedule')) {
      result = 'ops';
    }

    if (pathname.startsWith('/tasks') || pathname.startsWith('/client_lead')) {
      result = 'care';
    }

    if (result && result !== account) {
      handleSetAccount(result);
    }
  }, []);

  if (mobileApp) {
    // Don't show on mobile app
    return null;
  }


  if (smallScreen) {
    return (
      <NavbarSmallScreen account={account} setAccount={handleSetAccount} />
    );
  }

  return (
    <NavbarBigScreen account={account} setAccount={handleSetAccount} />
  );
};


NavBar.propTypes = {
  mobileApp: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  mobileApp: state.environment.mobileApp,
});

export default connect(mapStateToProps, dispatch)(React.memo(NavBar));
